import { computed } from 'vue'
import { usePage } from '@inertiajs/vue3'
import type { ComputedRef } from 'vue'
import type { SharedProps } from '../types'

/**
 * The brand identity of the deployment being served. Every sibling site
 * (top5remedies, wiserlifestyles, 5starremedies, ...) runs this codebase from
 * its own branch, so the name, domain, public URL, and support address are read
 * from shared props rather than written into the markup: a hardcoded brand
 * conflicts on every merge from master, and — because it sits mid-paragraph in
 * the legal copy, where a name of a different length makes Prettier re-wrap the
 * surrounding lines — drags the whole paragraph into the conflict with it.
 *
 * `siteName` is the spaced display form ("Top 5 Supplements"); `siteDomain` is
 * the branded domain the terms and disclaimer name the site by, capitalised and
 * without a scheme ("Top5Supplements.com"); `siteUrl` is the public URL to link.
 */
export function useSite(): {
    siteName: ComputedRef<string>
    siteDomain: ComputedRef<string>
    siteUrl: ComputedRef<string>
    supportEmail: ComputedRef<string>
} {
    const page = usePage<SharedProps>()

    return {
        siteName: computed<string>(() => page.props.siteName),
        siteDomain: computed<string>(() => page.props.siteDomain),
        siteUrl: computed<string>(() => page.props.siteUrl),
        supportEmail: computed<string>(() => page.props.supportEmail),
    }
}
